function sizeMasthead() {
	const mastheadRoot = document.querySelector('[data-masthead-root]')
	const { width } = mastheadRoot.getBoundingClientRect()

	mastheadRoot.style.setProperty('--masthead-root-width', `${width}px`)
}

window.addEventListener('DOMContentLoaded', () => {
	const siteHeader = document.querySelector('.site-header')
	const skipButton = document.querySelector('.js-skip-to-main')

	if (siteHeader) {
		siteHeader.classList.add('site-header--active')
	}

	if (skipButton) {
		skipButton.addEventListener('click', (e) => {
			const rect = skipButton.getBoundingClientRect()
			const destination = Math.round(rect.bottom) + 5 + window.scrollY

			window.scrollTo({
				top: destination,
				left: 0,
				behavior: 'smooth',
			})
		})
	}

	sizeMasthead()

	window.addEventListener('resize', sizeMasthead)
})
